import classnames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';

const STAR_SIZE = 12;
const STAR_COLOR = '#919191';

const useStyles = createUseStyles({
  star: {
    background: STAR_COLOR,
    composes: ['is-block', 'is-absolute', 'no-overflow', 'glitter'],
    height: STAR_SIZE,
    left: '50%',
    top: '50%',
    width: STAR_SIZE,
    zIndex: 2,
  },
  starBottom: {
    '&::after': {
      left: STAR_SIZE / 2,
      top: STAR_SIZE / 2,
    },
    '&::before': {
      left: -(STAR_SIZE / 2),
      top: STAR_SIZE / 2,
    },
  },
  starItem: {
    '&::before, &::after': {
      background: '#272727',
      borderRadius: '50%',
      content: '""',
      height: STAR_SIZE,
      position: 'absolute',
      width: STAR_SIZE,
    },
    composes: ['is-relative', 'is-block'],
  },
  starTop: {
    '&::after': {
      bottom: -(STAR_SIZE / 2),
      left: STAR_SIZE / 2,
    },
    '&::before': {
      left: -(STAR_SIZE / 2),
      top: -(STAR_SIZE / 2),
    },
  },
});

const StarItemComponent = React.memo(() => {
  const classes = useStyles();

  const rand = () => Math.random();

  return (
    <figure
      className={classes.star}
      style={{
        animationDelay: `${rand()}s`,
        left: `${rand() * 100}%`,
        top: `${rand() * 100}%`,
      }}>
      <figure className={classnames(classes.starTop, classes.starItem)} />
      <figure className={classnames(classes.starBottom, classes.starItem)} />
    </figure>
  );
});

StarItemComponent.displayName = 'StarItemComponent';

export default StarItemComponent;
